import { render, staticRenderFns } from "./ShippingLabelForm.vue?vue&type=template&id=b02ff4cc&scoped=true"
import script from "./ShippingLabelForm.vue?vue&type=script&lang=ts"
export * from "./ShippingLabelForm.vue?vue&type=script&lang=ts"
import style0 from "./ShippingLabelForm.vue?vue&type=style&index=0&id=b02ff4cc&prod&scoped=true&lang=css"
import style1 from "./ShippingLabelForm.vue?vue&type=style&index=1&id=b02ff4cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02ff4cc",
  null
  
)

export default component.exports